module.exports = __webpack_public_path__ + "static/media/icon_mesadetrabajo.33a77d7e.svg";